import { Box, Paper, Stack, useTheme, styled } from '@mui/material';
import React from 'react';

const StyledContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  minHeight: '90vh',
  maxHeight: 'auto',
  display: 'flex',
  justifyContent: 'center',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  overflow: 'auto',
}));

const StyledPaper = styled(Paper)({
  width: '65%',
  height: 'auto',
  maxHeight: 'auto',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  overflow: 'hidden'
});

const StyledContentStack = styled(Stack)(({ theme }) => ({
  width: '85%',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'hidden',
  overflowX: 'hidden',
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(5)
}));

interface BasicPageContainerProps {
    children: React.ReactNode;
  }

export const BasicPageContainer = ({ children }: BasicPageContainerProps) => {
  const theme = useTheme();

  return (
    <StyledContainer>
      <StyledPaper>
        <StyledContentStack>
          {children}
        </StyledContentStack>
      </StyledPaper>
    </StyledContainer>
  );
}
  


            